export const PRIORITY_STYLES = {
  critical: {
    label: 'Critical',
    bg: 'rgba(239, 68, 68, 0.12)',
    fg: '#ef4444',
    ring: 'rgba(239, 68, 68, 0.35)'
  },
  high: {
    label: 'High',
    bg: 'rgba(250, 173, 20, 0.15)',
    fg: '#f59e0b',
    ring: 'rgba(250, 173, 20, 0.35)'
  },
  medium: {
    label: 'Medium',
    bg: 'rgba(59, 130, 246, 0.15)',
    fg: '#3b82f6',
    ring: 'rgba(59, 130, 246, 0.35)'
  },
  low: {
    label: 'Low',
    bg: 'rgba(107, 114, 128, 0.12)',
    fg: '#6b7280',
    ring: 'rgba(107, 114, 128, 0.30)'
  }
}

export const PILLARS = [
  {
    key: 'exercise',
    label: 'Exercise',
    accent: '#f5222d',
    tint: '#fff1f0'
  },
  {
    key: 'nutrition',
    label: 'Nutrition',
    accent: '#52c41a',
    tint: '#f6ffed'
  },
  {
    key: 'sleep',
    label: 'Sleep',
    accent: '#1677ff',
    tint: '#e6f4ff'
  }
]

export const PILLAR_ICONS = {
  exercise: '🏋️',
  nutrition: '🥗',
  sleep: '😴'
}